var map = {
	"./company.svg": 4092,
	"./doctor.svg": 8675,
	"./finance.svg": 5656,
	"./hr.svg": 353,
	"./logo.svg": 1664,
	"./members.svg": 3521,
	"./questionnaire.svg": 2088,
	"./suggest.svg": 9674,
	"./system.svg": 8181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;